<template lang="html">

  <section class="login">
    <div class="pageHeading">
    <h1>Reset Password</h1>
    </div>

    <div v-show="waitingOnServer || emailSent">
    <span v-if="!emailSent">Sending Email...</span>
      <span v-if="emailSent">We emailed you a password reset link. If you have not received it in within 10 min, please check your spam folder<br/></span>
      <a href="https://www.grouptravelplanners.com/">
        <v-btn  v-if="emailSent" small color="primary" >Close</v-btn>
      </a>
    <v-progress-linear v-if="!emailSent" :indeterminate="true"></v-progress-linear>
    </div>

    <div v-show="!waitingOnServer && !emailSent">
    <span>If you forgot your password, we can email you a password reset link.</span>

    <form>

      <v-text-field
              v-validate="'required|email'"
              v-model="email"
              :error-messages="errors.collect('email')"
              label="Account E-mail Address"
              data-vv-name="email"
              required
      ></v-text-field>
      <p style="color: red" v-if="error.length > 0">{{error}}</p>


      <v-btn :disabled="email.trim().length < 3 || !email.includes('@') || !(email.trim().indexOf('.') < email.length -2) || waitingOnServer" color="primary" @click="sendResetLink">Reset Password
      </v-btn>
    </form>

    <br/>
    <p>Remember your password now? <router-link to="/Login">Login!</router-link></p>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'recovery',
    props: [],
    mounted() {
    },
    data() {
      return {
          waitingOnServer: false,
          emailSent: false,
          error: '',
          name: '',
          email: '',
          password: '',
          dictionary: {
              attributes: {
                  email: 'E-mail Address'
                  // custom attributes
              },
              custom: {
                  name: {
                      required: () => 'Email can not be empty',
                      max: 'The name field may not be greater than 10 characters'
                      // custom messages
                  },
                  select: {
                      required: 'Select field is required'
                  }
              }
          }
      }
    },
    methods: {
        sendResetLink() {
            this.waitingOnServer = true;
            var vueThis = this;
            this.$services.authmanagement.create({
                "action": "sendResetPwd",
                "value": { "email": vueThis.email.trim().toLowerCase()},
                "test": true

            }).then((result) => {
                console.log(result)
                vueThis.emailSent = true;
            }).catch(function(error){
                console.error('Error!', error);
                vueThis.error = error.message;
                vueThis.shakeThat = true;
                setTimeout(()=>{
                    vueThis.shakeThat = false
                }, 500)
            })
                .finally(() => {
                    vueThis.waitingOnServer = false;

                })
        }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.login {
}
</style>
